import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import {
    SprayProduct,
    SprayEquipmentSetId,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectRatePerHundredLitre } from '../../../../../ProductPage/components/ProductDetails/components/RatePerHundredLitreListItem/selectors';

export interface OwnProps {
    productId: ProductId;
    equipmentSetId: SprayEquipmentSetId;
    applicationRate: SprayApplicationRate;
    product: SprayProduct;
    unitTypeId: UnitTypeId;
    needHalfCalculation: boolean;
}

export interface ConnectedProps {
    ratePerTank: string;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductRatePerHundredLitreListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ratePerTank } = this.props;

        return <ListItem description="Rate per 100L" value={ratePerTank} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    ratePerTank: makeSelectRatePerHundredLitre()
});

export default connect(mapStateToProps)(
    SummaryProductRatePerHundredLitreListItemComponent
);
